import { CSSObject, IconProps } from '@chakra-ui/react';
import { BottomRowSchema } from '@/views/account/MyBets/Components/MyBetsCard/components/BottomRow/styles/BottomRow.styles';

export const bottomRowStyles: BottomRowSchema = {
  flexWrapper: {
    w: '100%',
  },
  buttonCashOutDesc: {
    w: '100%',
    height: '29px',
    fontWeight: 'bold',
    fontSize: 'sm',
    textTransform: 'uppercase',
    color: 'blackAlpha.800',
    paddingTop: '1px',
    textShadow: '0px 1px 0px rgba(255, 255, 255, 0.3)',
    sx: {
      '.cashoutValue': {
        color: 'blackAlpha.800',
      },
      '&:hover': {
        '.cashoutValue': {
          color: 'blackAlpha.800',
        },
      },
      '&:active': {
        '.cashoutValue': {
          color: 'blackAlpha.800',
        },
      },
    },
  },
  buttonCashOutAmount: {
    variant: 'primary',
    height: '29px',
    fontFamily: 'accent',
    fontWeight: 'bold',
  },
  flexOddsBoostBanner: {
    bg: 'beta.600',
    boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.15)',
    sx: {
      svg: {
        color: 'alpha.400',
      },
    },
  },
  textOddsBoost: {
    color: 'alpha.400',
    fontWeight: 'bold',
    textShadow: '0px 3px 4px rgba(0, 0, 0, 0.25)',
    fontFamily: 'accent',
    pt: '0.5',
  },
  iconOddsBoost: {
    fill: 'beta.400',
    color: 'beta.400',
  },
  vstackBetsWrapper: {
    w: '100%',
    ml: 'inherit',
  },
  buttonGroupWrapper: {
    w: '100%',
  },
  iconCashOut: {
    fill: 'currentColor',
    mt: 1,
  },
  cashoutText: {
    color: 'currentColor',
    pt: '1',
  },
  cashoutValue: {
    lineHeight: 'normal',
    pt: '1',
  },
};
export const LinkVenueName: CSSObject = {
  color: 'white',
  fontSize: 'xs',
  fontWeight: 'bold',
  ml: '26px',
};
export const RaceTime: CSSObject = {
  color: 'white',
  fontWeight: 'medium',
  alignSelf: 'flex-end',
  ml: '26px',
};
export const BonusBetCheckMark: CSSObject = {
  '&&': {
    display: 'none',
  },
};
export const BonusBetText: CSSObject = {
  color: 'beta.100',
  fontSize: 'xs',
  fontWeight: 'bold',
  textTransform: 'uppercase',
  fontFamily: 'accent',
  bg: 'blackAlpha.500',
  borderRadius: 'base',
  boxShadow:
    '0px 1px 0px 0px rgba(255, 255, 255, 0.08), 0px 2px 0px 0px rgba(0, 0, 0, 0.3) inset',
  px: '2',
  py: '4px',
  lineHeight: 'normal',
};
export const BetReturn: CSSObject = {
  bg: 'blackAlpha.600',
  boxShadow:
    '0px 1px 0px 0px rgba(255, 255, 255, 0.13), 0px 2px 4px 0px rgba(0, 0, 0, 0.2) inset',
  color: 'white',
  borderRadius: 'base',
  fontWeight: 'medium',
  fontSize: '2xs',
};
export const BoxBetReturnValue: CSSObject = {
  py: '0.5',
  p: '1',
  fontWeight: 'black',
  color: 'alpha.300',
};
export const BoxBetReturnText: CSSObject = {
  my: '1',
  px: '1',
  borderRight: '1px solid',
  borderRightColor: 'whiteAlpha.400',
};
export const iconLegProps: IconProps = {
  boxSize: '18px',
  color: 'orange.500',
  bg: 'white',
  borderColor: 'white',
};
